
export default function About() {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-green-800">About Us</h2>
      <p className="mt-4">Officially registered private clinic under the Department of Ayurveda, Sri Lanka. 
        We specialize in Ayurvedic treatments using herbal and natural remedies.</p>
        <p className="mt-4">Patient Privacy & Confidentiality: 
          We are committed to maintaining the highest standards of patient privacy and confidentiality.</p>

        <p className="mt-4">Our licensed doctors provide personalized care tailored to your dosha balance.</p>
    </div>
  );
}
